import { Outlet, useOutletContext } from 'react-router-dom'

import { Spinner } from '@factorialco/f0-react/dist/experimental'
import { CoCreationEnabledDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMemo } from 'modules/core/hooks/useMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { FormPreviewInline } from 'modules/forms'
import NewFormEditor from 'modules/forms/components/newFormEditor'
import { QuestionnaireType } from 'modules/forms/components/newFormEditor/types'
import { TrainingFormContextType } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/TrainingFormDetail/types'

const PublishedQuestions = () => {
  const context = useOutletContext<TrainingFormContextType>()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(CoCreationEnabledDocument, {
    variables: { companyId: company.id },
  })

  const { trainingForm } = context
  const { navigation } = useNavigation()

  const coCreationEnabled =
    data?.features?.featuresConnection?.nodes.find(
      (feature) => feature.name === 'dev_forms_ai_cocreation'
    )?.enabled ?? false

  const emptyNavigateAction = useMemo(() => {
    if (trainingForm.resourceId) {
      return navigation.trainings.list.details_revamp.trainingSurveyDetail.edit.fullPath({
        id: String(trainingForm.resourceId),
        formId: String(trainingForm.id),
      })
    } else {
      return navigation.trainings.list.surveyTemplates.templateDetails.edit.fullPath({
        templateId: String(trainingForm.id),
      })
    }
  }, [trainingForm.id])

  if (loading) {
    return <Spinner />
  }

  const handleChange = (questionnaire: QuestionnaireType) => {
    context.setQuestionnaire?.(questionnaire)
  }

  if (coCreationEnabled) {
    return (
      <>
        <NewFormEditor
          id={trainingForm.id}
          resourceType={trainingForm.resourceType}
          setForm={handleChange}
        />
        <Outlet context={context} />
      </>
    )
  }

  return (
    <>
      <FormPreviewInline
        formId={trainingForm.id}
        resourceId={trainingForm.resourceId ?? undefined}
        resourceType={trainingForm.resourceType}
        materializedForms={trainingForm.materializedForms}
        emptyNavigateAction={`${emptyNavigateAction}?create=true`}
      />
      <Outlet context={context} />
    </>
  )
}

export default PublishedQuestions
